import { ECompanyType, ICompany } from '../models/company.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getList(
  query: IPaginationQuery & {
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
    type?: ECompanyType;
  },
) {
  return request<IPaginationData<ICompany>>({
    url: '/company',
    method: 'GET',
    params: query,
  });
}

function getDetail(id: string) {
  return request<ICompany>({
    url: `/company/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<ICompany>) {
  return request<ICompany>({
    url: `/company`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<ICompany>) {
  return request<ICompany>({
    url: `/company/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<ICompany>({
    url: `/company/${id}`,
    method: 'DELETE',
  });
}

const companyApi = Object.freeze({
  getList,
  getDetail,
  update,
  create,
  remove,
});

export default companyApi;
